"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateTitle = generateTitle;
var _store = _interopRequireDefault(require("../store"));
// translate router.meta.title, be used in breadcrumb sidebar tagsview

// export function generateTitle(title) {
//   const hasKey = this.$te('route.' + title)
//   console.log(store)
//   if (hasKey) {
//     // $t :this method from vue-i18n, inject in @/lang/index.js
//     const translatedTitle = this.$t('route.' + title)

//     return translatedTitle
//   }
//   return title
// }

function generateTitle(_ref) {
  var titleCn = _ref.titleCn,
    titleEn = _ref.titleEn,
    title = _ref.title,
    pathType = _ref.pathType;
  if (!(titleCn && titleEn)) {
    if (pathType === 'BUTTON') {
      var hasKey = this.$te('btn.' + title);
      if (hasKey) {
        return this.$t('btn.' + title);
      }
    } else {
      var _hasKey = this.$te('route.' + title);
      if (_hasKey) {
        return this.$t('route.' + title);
      }
    }
    return title;
  } else {
    if (_store.default.getters.language === 'zh') {
      return titleCn;
    } else {
      return titleEn;
    }
  }
}